<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="close(false)"></button>
      <h1 class="layerTitle notranslate">{{locale.payment_userinfo}}</h1>
      <div>
        <div v-if="inputs.firstName" class="formGroup isRequired mb15 notranslate">
          <label class="label toCapitalize">{{locale.first_name}}</label>
          <input type="text" class="input" v-model="userInfo.firstName" required>
        </div>
        <div v-if="inputs.lastName" class="formGroup isRequired mb15 notranslate">
          <label class="label toCapitalize">{{locale.last_name}}</label>
          <input type="text" class="input" v-model="userInfo.lastName" required>
        </div>
        <!-- <div class="formGroup isRequired mb15">
          <label class="label">{{locale.telephone}}</label>
          <vue-tel-input
            class="telInput input"
            :mode="'national'"
            :autoDefaultCountry="true"
            :validCharactersOnly="true"
            @input ="inputTel"></vue-tel-input>
        </div> -->
        <div v-if="inputs.tel" class="formGroup isRequired mt15 telInputWithSearch notranslate">
          <label class="label toCapitalize">{{locale.telephone}}</label>
          <div v-show="openCountry" class="searchCountry">
            <input
              type="text"
              class="input"
              placeholder="country name or code"
              ref="searchInput"
              v-model="searchCountry"
              @focus.stop
              @click.stop
              @keyup.enter="setSearchCountry" />
            <button type="button" class="btn btnPrimary btnSearch" @click.stop="setSearchCountry">
              {{locale.search}}
            </button>
          </div>
          <vue-tel-input
            class="telInput input"
            ref="telInput"
            :mode="'national'"
            :autoDefaultCountry="true"
            :preferredCountries="filteredCountry"
            :validCharactersOnly="true"
            @input="inputTel"
            @open="toggleCountry(true)"
            @close="toggleCountry(false)"></vue-tel-input>
        </div>
        <div v-if="inputs.email" class="formGroup isRequired mb15 notranslate">
          <label class="label toCapitalize">{{locale.email}}</label>
          <input type="email" class="input" v-model="userInfo.email" required>
        </div>
        <!-- custom inputs -->
        <div v-if="inputs.custom">
          <div
            v-for="item in inputs.custom"
            :key="item.id">
            <div class="formGroup isRequired mb15">
              <label class="label toCapitalize">{{item.label[lang]}}</label>
              <input v-if="item.type === 'input'" type="text" class="input" v-model="userInfo[item.id]" required>
              <select v-else-if="item.type === 'select'" class="input select" v-model="userInfo[item.id]" required>
                <option value="">{{locale.message_select}}</option>
                <option
                  v-for="(option, i) in item.selectOption"
                  :key="i"
                  :value="option[lang]">
                  {{option[lang]}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <!-- //custom inputs -->
        <div class="btns mt30 notranslate">
          <button
            type="button"
            class="btn btnFull"
            :disabled="!isValid"
            @click="submit">
            {{locale.input_complete}}
          </button>
        </div>
      </div>
    </div>
    <div v-if="toastList">
      <Toast v-for="toast in toastList"
        :locale="locale"
        :key="toast.id"
        :toast="toast"
        @confirm="toastConfirm" />
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import UNIQUE from '@/common/unique'
import Toast from '@/components/Util/Toast'

export default {
  name: 'PaymentUserInfo',
  props: [
    'lang',
    'locale'
  ],
  components: {
    Toast
  },
  computed: {
    filteredCountry () {
      const word = regExp.replaceAllEmpty(this.searchCountry).toLowerCase()
      const findCountry = this.countryList.filter(x => {
        const iso2 = regExp.replaceAllEmpty(x.iso2).toLowerCase().includes(word)
        const dialCode = regExp.replaceAllEmpty(`+${x.dialCode}`).toLowerCase().includes(word)
        const name = regExp.replaceAllEmpty(x.name).toLowerCase().includes(word)
        return word.length > 0 && (iso2 || dialCode || name)
      }).map(x => x.iso2)
      return findCountry
    },
    isValid () {
      const firstName = this.inputs.firstName ? this.userInfo.firstName !== '' : true
      const lastName = this.inputs.lastName ? this.userInfo.lastName !== '' : true
      const phone = this.inputs.tel ? this.userInfo.phone !== '' && this.validatePhone.valid : true
      const email = this.inputs.email ? this.userInfo.email !== '' : true
      // 커스텀 옵션 빈값 체크
      const customs = this.inputs.custom ? Object.keys(this.userInfo).filter(x => x.startsWith('custom')).map(key => {
        return this.userInfo[key]
      }).filter(x => x === '').length === 0 : true
      return firstName && lastName && phone && email && customs
    },
    inputs () {
      return this.$store.getters['common/getUserinfo']
    }
  },
  created () {
    const inputs = this.inputs
    const isFirstName = inputs.firstName !== false
    const isLastName = inputs.lastName !== false
    const isTel = inputs.tel !== false
    const isEmail = inputs.email !== false
    const isCustom = inputs.custom && inputs.custom.length > 0
    if (!isFirstName && !isLastName && !isTel && !isEmail && !isCustom) {
      // this.$destroy()
    }
  },
  mounted () {
    function getValueType (type) {
      let result = ''
      switch (type) {
        case 'input':
          result = ''
          break
        case 'select':
          result = ''
          break
        default:
          result = ''
          break
      }
      return result
    }
    this.$root.$el.append(this.$el)
    this.$nextTick(() => {
      this.countryList = this.$refs.telInput ? this.$refs.telInput.allCountries : []
      if (this.inputs && this.inputs.custom && this.inputs.custom.length) {
        const custom = this.inputs.custom
        const customUserinfo = function (arr) {
          const result = {}
          for (let i = 0; i < arr.length; i++) {
            const id = arr[i].id
            result[id] = getValueType(arr[i].type)
          }
          return result
        }
        this.userInfo = {
          ...this.userInfo,
          ...customUserinfo(custom)
        }
      }
    })
  },
  beforeDestroy () {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  data () {
    return {
      userInfo: {
        firstName: '',
        lastName: '',
        phone: '',
        email: ''
      },
      searchCountry: '',
      openCountry: false,
      countryList: [],
      validatePhone: {},
      toastList: []
    }
  },
  methods: {
    addToast (trigger, type, message, otherData) {
      const id = UNIQUE.mid()
      const toast = {
        id: id,
        type: type,
        trigger: trigger,
        message: message,
        ...otherData
      }
      this.toastList.push(toast)
    },
    delToast (id) {
      this.toastList = id ? this.toastList.filter(x => x.id !== id) : []
    },
    toastConfirm (data) {
      const trigger = this.toastList.find(x => x.id === data.id) ? this.toastList.find(x => x.id === data.id).trigger : null
      if (!data.isConfirm) {
        this.delToast(data.id)
      } else {
        if (trigger) {
          if (trigger === 'closeUserInfo') {
            this.$emit('confirm', data.otherData.isOpen)
          }
        } else {
          alert(this.locale.alert_system_error)
        }
      }
    },
    changeCountry (data) {
      this.currentCountry = data.iso2
    },
    setSearchCountry () {
      const value = this.$refs.searchInput.value
      this.searchCountry = value
    },
    toggleCountry (isOpen) {
      this.openCountry = isOpen
      if (isOpen) {
        const findInput = this.$refs.searchInput
        if (findInput) {
          this.$nextTick(() => findInput.focus())
        }
      }
    },
    inputTel (number, telObj) {
      this.validatePhone = telObj
      this.userInfo.phone = telObj.number
    },
    close (confirm) {
      this.addToast('closeUserInfo', 'confirm', this.locale.confirm_close_payment_userinfo, { otherData: { isOpen: confirm } })
    },
    submit () {
      function getCustomData (arr, obj) {
        const result = {}
        for (let i = 0; i < arr.length; i++) {
          const id = arr[i].id
          result[id] = {
            label: arr[i].label,
            value: obj[id],
            ...arr[i].type === 'input' && arr[i].translate && {
              translate: arr[i].translate
            }
          }
        }
        return result
      }
      if (this.inputs.tel && !this.validatePhone.valid) {
        alert(this.locale.alert_invalid_phone)
      } else {
        const customUserinfo = this.inputs.custom
        const userInfo = {
          firstName: this.userInfo.firstName,
          lastName: this.userInfo.lastName,
          ...this.inputs.tel && {
            phone: this.userInfo.phone
          },
          ...this.inputs.email && {
            email: this.userInfo.email
          },
          ...customUserinfo && {
            ...getCustomData(this.inputs.custom, this.userInfo)
          }
        }
        this.$store.commit('payment/setUserInfo', userInfo)
        this.$emit('confirm', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  z-index: 9999999;
  .inner {
    height: auto !important;
    padding: 30px 15px;
    border-radius: 8px;
    text-align: initial;
  }
}
</style>
